<div class="waiting-container">
  @if($phase()==='loading'){
  <ion-spinner name="crescent" class="big-spinner"></ion-spinner>
  }
  @else {
  <div class="card-skeleton">
    <div class="chip"></div>
    <div class="line l1"></div>
    <div class="line l2"></div>
  </div>

  <h3 class="title">{{ 'CDC_AUTHENTICATION.WAITING.TITLE' | translate }}</h3>

  <ul class="steps">
    <li [class]="stepState('submit')">
      @if(stepState('submit')==='active'){
      <ion-spinner name="crescent"></ion-spinner>
      } @else {
      <ion-icon name="checkmark-circle" color="success"></ion-icon>
      }
      <span>{{ 'CDC_AUTHENTICATION.WAITING.STEP_SUBMIT' | translate }}</span>
    </li>
    <li [class]="stepState('bank')">
      @if(stepState('bank')==='active'){
      <ion-spinner name="crescent"></ion-spinner>
      } @else {
      <ion-icon name="ellipse-outline"></ion-icon>
      }
      <span>{{ 'CDC_AUTHENTICATION.WAITING.STEP_BANK' | translate }}</span>
    </li>
  </ul>

  @if($phase()==='bank'){
  <p class="hint">{{ 'CDC_AUTHENTICATION.WAITING.BANK_HINT' | translate }}</p>
  }
  }
</div>
